<template>
  <div id="app">
    <div class="col-12 col-md-4 offset-md-4 mt-5">
      <div class="text-center mb-5 mt-1">
        <h2><v-icon name="md-searchoff" scale="6.5" /></h2>
        <h3>¡Ups! Algo ha salido mal</h3><br>
        <h5>No hemos podido encontrar lo que buscas.<br><br>

          Al parecer, la página no existe o ha ocurrido algún error en el proceso.</h5>
      </div>
      <div class="col-12 mt-1 text-center">
        <button class="btn btn-primary" @click="back()">Volver</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  methods: {
    back() {
      this.$router.back()
    },
  },
};
</script>

<style lang="scss"></style>
